import { render, staticRenderFns } from "./processBody.vue?vue&type=template&id=01c2efbe&scoped=true"
import script from "./processBody.vue?vue&type=script&lang=js"
export * from "./processBody.vue?vue&type=script&lang=js"
import style0 from "./processBody.vue?vue&type=style&index=0&id=01c2efbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c2efbe",
  null
  
)

export default component.exports